import { render, staticRenderFns } from "./payDetail.vue?vue&type=template&id=6c6b1d82&scoped=true"
import script from "./payDetail.vue?vue&type=script&lang=js"
export * from "./payDetail.vue?vue&type=script&lang=js"
import style0 from "./payDetail.vue?vue&type=style&index=0&id=6c6b1d82&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6b1d82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c6b1d82')) {
      api.createRecord('6c6b1d82', component.options)
    } else {
      api.reload('6c6b1d82', component.options)
    }
    module.hot.accept("./payDetail.vue?vue&type=template&id=6c6b1d82&scoped=true", function () {
      api.rerender('6c6b1d82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/orderpay/payDetail.vue"
export default component.exports